import { useState } from "react";
import { useInfiniteQuery } from '@tanstack/react-query';
import { getUnsplashImages } from "../api/unsplash";
import { getSplashInfiniteQuerie } from "../types/queries";

const defaultUnplashSearchParams = {
    keyword: "texture",
    enabled: false
}

export const unplashHook = () => {
    const [unsplashSearchParams, setUnsplashSearchParams] = useState({
        ...defaultUnplashSearchParams
    });

    const unsplashSearchHandler = (args: any) => {
        setUnsplashSearchParams({
            ...defaultUnplashSearchParams,
            ...args
        });
    }

    // Unplash ImagesQuery
    const unsplashImages = useInfiniteQuery({
        queryKey: getSplashInfiniteQuerie(unsplashSearchParams.keyword),
        queryFn: ({ pageParam }) => getUnsplashImages(unsplashSearchParams.keyword, pageParam),
        initialPageParam: 1,
        enabled: unsplashSearchParams.enabled,
        getNextPageParam: (lastGroup, allGroups) => lastGroup.total_pages >= allGroups.length + 1 ? allGroups.length + 1 : null
    });

    return { unsplashImages, unsplashSearchHandler };
}